module.exports = __webpack_public_path__ + "static/Highline_Final-a7e95b6220172c76d7a9d48cbab0e76b.png";